import React, { Component } from 'react';
import { fetchConfigurationSetAppData, refreshConfigurationSets } from '../store/appData';
import { withTranslation } from 'react-i18next';
import { Grid, Pagination, Typography } from '@mui/material';

import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons';
import Backdrop from '../../../common/components/UI/Backdrop/Backdrop';
import Snackbar from '../../../common/components/UI/Snackbar/Snackbar';
import CustomButton from '../../../common/components/UI/Button/Button';
import SearchInput from '../../../common/components/UI/Search/SearchInput';
import SideBar from '../../../common/components/UI/SideBar/SideBar';
import SimpleDialog from '../../../common/components/UI/Dialog/SimpleDialog';
import SuccesAnimated from '../../../common/components/UI/SuccessAnimated/SuccessAnimated'
import Form from '../components/Form';
import ConfigurationSetTable from '../components/ConfigurationSetTable';
import ReactSelect from '../../../common/components/UI/Select/ReactSelect';
import * as aux from "../../auxilaries";
import { currentHttpOptions, formatResponse } from '../../utils'
import { AdminSidePanelActionNames, PrivateEmployeeSource, PtoActionOnRejection, RequestSubtypeNames, RequestTypeNames, RuleSetType } from '../../Enums';
import { connect } from 'react-redux';
import './ConfigurationSet.scss';

const PAGE_SIZE_OPTIONS = [
    { label: "10", value: 10 },
    { label: "25", value: 25 },
    { label: "50", value: 50 },
    { label: "100", value: 100 },
];

/**
 * @typedef {typeof AdminSidePanelActionNames[keyof AdminSidePanelActionNames]} IAdminSidePanelActionNames
 */

class EBAdminSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openForm: false,
            sideAction: '',
            displaySpinner: true,
            settingList: [],
            filteredsettingList: [],
            hyperFindList: [],
            workRuleList: [],
            segmentTagsList: [],
            payCodeList: [],
            sortBySelected: '',
            sortOrder: 'Ascending',
            currentPage: 1,
            selectedPageSize: PAGE_SIZE_OPTIONS[0],
            actionTypeList: [
                { label: "To Cover", value: 0 },
                { label: "Shift Swap", value: 1 },
                { label: "Open Shift", value: 2 },
                { label: "Voluntary Time Off", value: 3 }
            ],
            showDeleteDialog: false,
            showArchiveDialog: false,
            responseStatus: '',
            showResponseDialog: '',
            settingSelected: {},
            responseStatusText: '',
            searchValue: '',
            typeSnackbar: 'success',
            messageSnackbar: '',
            openSnackbar: false,
            timePeriodRatioOptions: [],
            privateEmployeeSources: [
                {label: "Manager Home Location", value: PrivateEmployeeSource.ManagerHomeLocation},
                {label: "Hyperfind", value: PrivateEmployeeSource.Hyperfind},
            ],
            ptoActionOnRejectionOptions: [],
            breakRuleList: []
        }
    }

    async componentDidMount(){
        const { isConfigurationSetAppDataLoaded, fetchConfigurationSetAppData } = this.props;
        if (!isConfigurationSetAppDataLoaded) {
            await fetchConfigurationSetAppData();
        }

        const {
            settingList, hyperFindList, segmentTagsList, workRuleList, dataviews, payCodeList, awardingRulesList, genericNotificationList, timePeriodRatioOptions, breakRuleList
        } = this.props;
        const { t } = this.props;
        const unarchivedSettings = settingList.filter(x => !x.isArchive);
        await this.setState({
            settingList: unarchivedSettings,
            filteredsettingList: unarchivedSettings,
            hyperFindList: hyperFindList,
            segmentTagsList: segmentTagsList,
            workRuleList: workRuleList,
            dataviewList: formatResponse(dataviews, 'id', true),
            payCodeList: payCodeList,
            awardingRulesList: awardingRulesList,
            genericNotificationList: genericNotificationList,
            timePeriodRatioOptions: timePeriodRatioOptions,
            displaySpinner: false,
            breakRuleList: breakRuleList,
            ptoActionOnRejectionOptions: [
                { label: t("settings.ptoActionOnRejectionOptions.submitted"), value: PtoActionOnRejection.Submitted },
                { label: t("settings.ptoActionOnRejectionOptions.refused"), value: PtoActionOnRejection.Refused },
                { label: t("settings.ptoActionOnRejectionOptions.cancelled"), value: PtoActionOnRejection.Cancelled },
            ],
        }, () => this.handleSearchFilter());
    }

    handleRefreshSettings = async () => {
        const { refreshConfigurationSets } = this.props;
        await refreshConfigurationSets();

        const { settingList } = this.props;
        const unarchivedSettings = settingList.filter(x => !x.isArchive);
        
        await this.setState({
            settingList: unarchivedSettings,
            filteredsettingList: unarchivedSettings,
        }, () => this.handleSearchFilter());
    }

    closeResponseDialog = () => {
        setTimeout(() => {
            this.setState({ showResponseDialog: false })
        }, 3000)
    }

    handleSubmitForm = (form) => {
        const { t } = this.props
        const { settingSelected, settingList, sideAction } = this.state;
        this.displaySpinner(true);
        const options = currentHttpOptions();
        if (sideAction === AdminSidePanelActionNames.Edit) {
            return axios.post(process.env.REACT_APP_API_DOTNET + '/api/v1/admin/adminSettings/UpdateSetting', {
                ...form,
                AdminSettingsId: settingSelected.id
            }, options).then((response) => {
                let responseStatusText = t('admin.successEdit');
                const updatedSettingList = settingList.map(x => {
                    if (x.id === settingSelected.id) {
                        return response.data;
                    }
                    return x;
                })
                this.setState({
                    responseStatus: 'success',
                    showResponseDialog: true,
                    responseStatusText: responseStatusText,
                    settingSelected: {},
                    settingList: updatedSettingList,
                    filteredsettingList: updatedSettingList,
                })

                this.closePanelHandler();
                this.handleRefreshSettings();
            }).catch(err => {
                this.handleSnackbar('error', err.response.data.Message, true);
            }).finally(() => {
                this.displaySpinner(false);
                this.closeResponseDialog();
                this.handleSearchFilter()
            })
        }

        return axios.post(process.env.REACT_APP_API_DOTNET + '/api/v1/admin/adminSettings/AddSetting', form, options).then(() => {
            let responseStatusText;

            if (sideAction === AdminSidePanelActionNames.Duplicate) {
                responseStatusText = t('admin.successDuplicate')
            } else {
                responseStatusText = t('admin.successCreate')
            }

            this.setState({
                responseStatus: 'success',
                showResponseDialog: true,
                responseStatusText: responseStatusText,
                settingSelected: {},
            })

            this.closePanelHandler();
            this.handleRefreshSettings();
        }).catch(err => {
            this.handleSnackbar('error', err.response.data.Message, true);
        }).finally(e => {
            this.displaySpinner(false);
            this.closeResponseDialog();
            this.handleSearchFilter()
        })
    }

    displaySpinner = (displaySpinner) => {
        this.setState({ displaySpinner })
    }

    handleSnackbar = (type, message, openState) => {
        this.setState({
            typeSnackbar: type,
            messageSnackbar: message,
            openSnackbar: openState,
        })
    }

    closeSnackbar = () => {
        setTimeout(() => {
            this.setState({ openSnackbar: false });
        }, 5000)
    }

    closePanelHandler = () => {
        this.setState({ openForm: false })
    }

    compareString = (a, b) => {
        var x,y;
        if(this.state.sortBySelected === "actionType") {
            x = a[this.state.sortBySelected] != null ? RequestTypeNames[a[this.state.sortBySelected]].toString().toLowerCase() : '';
            y = b[this.state.sortBySelected] != null ? RequestTypeNames[b[this.state.sortBySelected]].toString().toLowerCase() : '';
        }else if( this.state.sortBySelected === "requestSubtype"){
            x = a[this.state.sortBySelected] != null ? RequestSubtypeNames[a[this.state.sortBySelected]].toString().toLowerCase() : '';
            y = b[this.state.sortBySelected] != null ? RequestSubtypeNames[b[this.state.sortBySelected]].toString().toLowerCase() : '';
        } else if(this.state.sortBySelected === "creationHyperfindId") {
            const hyperfindA = this.state.hyperFindList.find(h => h.value === a[this.state.sortBySelected]);
            const hyperfindB = this.state.hyperFindList.find(h => h.value === b[this.state.sortBySelected]);
            x = hyperfindA ? hyperfindA.label.toString().toLowerCase() : '';
            y = hyperfindB ? hyperfindB.label.toString().toLowerCase() : '';
        } else if(this.state.sortBySelected === "managementHyperfindId") {
            const hyperfindA = this.state.hyperFindList.find(h => h.value === a[this.state.sortBySelected]);
            const hyperfindB = this.state.hyperFindList.find(h => h.value === b[this.state.sortBySelected]);
            x = hyperfindA ? hyperfindA.label.toString().toLowerCase() : '';
            y = hyperfindB ? hyperfindB.label.toString().toLowerCase() : '';
        } else{
            x = a[this.state.sortBySelected] != null ? a[this.state.sortBySelected].toString().toLowerCase() : '';
            y = b[this.state.sortBySelected] != null ? b[this.state.sortBySelected].toString().toLowerCase() : '';
        }
        if (x < y) { return -1; }
        if (x > y) { return 1; }
        return 0;
    }

    sortBy = (sortIndex) => {
        var oldSortBy = this.state.sortBySelected;
        this.setState({ sortBySelected: sortIndex },
            () => {
                if (oldSortBy === sortIndex) {
                    let sortOrder = this.state.sortOrder === 'Ascending' ? 'Descending' : 'Ascending'
                    this.setState({ settingList: this.state.settingList.reverse(), sortOrder });
                } else {
                    let sortOrder = this.state.sortOrder === 'Ascending' ? 'Descending' : 'Ascending'
                    this.setState({ settingList: this.state.settingList.sort(this.compareString), sortOrder });
                }
            }
        )
    }

    cancelAction = () => {
        this.setState({
            openForm: false,
            showDeleteDialog: false,
            showArchiveDialog: false,
            sideAction: '',
            spinnerShow: false,
        })
    }

    /**
     * @param {IAdminSidePanelActionNames} sideAction 
     * @param {*} settingSelected 
     */
    rightPanelHandler = (sideAction, settingSelected) => {
        /** @type {typeof this.state} */
        let state = {
            sideAction,
            settingSelected,
        };

        switch (sideAction) {
            case AdminSidePanelActionNames.Delete:
                state = {
                    ...state,
                    showDeleteDialog: true,
                };
                break;
            case AdminSidePanelActionNames.Archive:
                state = {
                    ...state,
                    showArchiveDialog: true,
                };
                break;
            default:
                state = {
                    ...state,
                    openForm: true,
                };
            break;
        }

        this.setState(state);
    }

    deleteItem = async () => {
        const { t } = this.props
        const { settingSelected, settingList } = this.state
        const options = currentHttpOptions()
        let message = '';
        this.displaySpinner(true)
        let deleteAction = await axios.delete(process.env.REACT_APP_API_DOTNET + '/api/v1/admin/adminSettings/DeleteSetting/' + settingSelected.id, options)
            .catch(err => {
                message = aux.handleAPIErrors(err.response)
            }).finally(() => {
                this.displaySpinner(false)
            });
        let settingListAux = settingList.filter((element) => element.id !== settingSelected.id)
        if (!deleteAction) { //deleteAction is undefined
            this.setState({
                responseStatus: 'error',
                showResponseDialog: true,
                responseStatusText: message,
                settingSelected: {},
                showDeleteDialog: false,
            })
        }
        else if (typeof deleteAction.data.error === 'undefined') {
            this.setState({
                settingList: settingListAux,
                filteredsettingList: settingListAux,
                responseStatus: 'success',
                showResponseDialog: true,
                responseStatusText: t('admin.successDelete'),
                settingSelected: {},
                showDeleteDialog: false,
            }, () => this.handleSearchFilter())
        }
        else {
            this.setState({
                responseStatus: 'error',
                showResponseDialog: true,
                responseStatusText: typeof deleteAction.data.error !== 'undefined' ? deleteAction.data.error : deleteAction.data,
                settingSelected: {},
                showDeleteDialog: false,
            })
        }
        this.displaySpinner(false)
        this.closeResponseDialog()
    }

    archiveItem = async () => {
        const { t } = this.props
        const { settingSelected: { id: adminSettingId }, settingList } = this.state
        const options = currentHttpOptions()
        let message = '';
        this.displaySpinner(true)
        const url = `${process.env.REACT_APP_API_DOTNET}/api/v1/admin/adminSettings/archive/${adminSettingId}`;
        let archiveAction = await axios.put(url, {}, options)
            .catch(err => {
                message = aux.handleAPIErrors(err.response)
            }).finally(() => {
                this.displaySpinner(false)
            });
        let settingListAux = settingList.filter((element) => element.id !== adminSettingId)
        if (!archiveAction) { //archiveAction is undefined
            this.setState({
                responseStatus: 'error',
                showResponseDialog: true,
                responseStatusText: message,
                settingSelected: {},
                showArchiveDialog: false,
            })
        }
        else if (typeof archiveAction.data.error === 'undefined') {
            this.setState({
                settingList: settingListAux,
                filteredsettingList: settingListAux,
                responseStatus: 'success',
                showResponseDialog: true,
                responseStatusText: t('settings.successArchived'),
                settingSelected: {},
                showArchiveDialog: false,
            }, () => {
                this.handleSearchFilter();
                this.handleRefreshSettings();
            })
        }
        else {
            this.setState({
                responseStatus: 'error',
                showResponseDialog: true,
                responseStatusText: typeof archiveAction.data.error !== 'undefined' ? archiveAction.data.error : archiveAction.data,
                settingSelected: {},
                showArchiveDialog: false,
            })
        }
        this.displaySpinner(false)
        this.closeResponseDialog()
    }

    handleSearchFilter = (event) => {
        const { searchValue, settingList } = this.state;
        const searchableFields = ['name', 'creationHyperfindId', 'managementHyperfindId', 'description']

        let filteredSettings = [];

        let searchFilter = event === undefined ? searchValue : (event.target.value === undefined) ? searchValue : event.target.value;

        if (searchFilter !== '') {
            for (const setting of settingList) {
                for (const key in setting) {
                    if (searchableFields.includes(key)
                        && setting[key] !== null
                        && setting[key].toString().toLowerCase().includes(searchFilter.toLowerCase())) {
                        filteredSettings.push(setting)
                        break;
                    }
                }
            }
        } else {
            filteredSettings = settingList;
        }

        this.setState({
            searchValue: searchFilter,
            filteredsettingList: filteredSettings,
            currentPage: 1,
        })
    }

    handlePageChange = (_event, page) => {
        this.setState({ currentPage: page });
    }

    handlePageSizeChange = (_name, option) => {
        this.setState({ selectedPageSize: option, currentPage: 1 });
    }

    render() {
        const { t, breRuleSetList } = this.props;
        const {
            actionTypeList, awardingRulesList, dataviewList, displaySpinner, filteredsettingList,
            genericNotificationList, hyperFindList, messageSnackbar, openForm, openSnackbar, payCodeList, responseStatus,
            responseStatusText, searchValue, segmentTagsList, settingList, settingSelected, showArchiveDialog, showDeleteDialog,
            showResponseDialog, sideAction, sortBySelected, sortOrder, timePeriodRatioOptions, typeSnackbar, workRuleList, privateEmployeeSources,
            ptoActionOnRejectionOptions, breakRuleList, currentPage, selectedPageSize,
        } = this.state;

        const updatedFilteredListSettings = filteredsettingList.map((setting) => {
            const matchingBreRule = breRuleSetList.find(rule => rule.id === setting.breRuleSetId);
            const matchingAwardingRule = awardingRulesList.find(awarding => awarding.id === setting.awardingRuleId)
            return {
                ...setting,
                breRuleSetName: matchingBreRule ? matchingBreRule.name : null,
                awardingRuleName: matchingAwardingRule ? matchingAwardingRule.name : null,
            };
        });

        const filteredCount = updatedFilteredListSettings.length;
        const totalPages = Math.ceil(filteredCount / selectedPageSize.value);
        const startIndex = (currentPage - 1) * selectedPageSize.value;
        const paginatedList = updatedFilteredListSettings.slice(startIndex, startIndex + selectedPageSize.value);
        const from = filteredCount === 0 ? 0 : startIndex + 1;
        const to = Math.min(startIndex + selectedPageSize.value, filteredCount);
        

        const formTitle = sideAction === AdminSidePanelActionNames.Edit
            ? t('settings.adminSidePanelHeaderEdit')
            : t('settings.adminSidePanelHeader');

        let header = (
            <React.Fragment>
                <Grid container sx={{ columnGap: '20px' }}>
                    <Grid className="admin-config-top-buttons" item xs="auto" >
                        <CustomButton
                            size={'medium'}
                            color={'primary'}
                            sx={{
                                width: '200px',
                                textTransform: 'capitalize',
                                '&.primary': {
                                    backgroundColor: 'var(--B400)',
                                    '& svg path': { fill: 'white' },
                                    '&:hover': {
                                        backgroundColor: '#2347B2',
                                        '& svg path': { fill: 'white' },
                                    },
                                },
                            }}
                            onClick={() => {
                                this.setState({
                                    sideAction: AdminSidePanelActionNames.Create,
                                    openForm: true
                                })
                            }}
                        >
                            <FontAwesomeIcon icon={faPlusCircle} />
                            {t('settings.addNew')}
                        </CustomButton>
                    </Grid>
                    <Grid className="admin-config-top-buttons" item xs={6} >
                        <SearchInput
                            fullWidth={true}
                            value={searchValue}
                            placeholder={t('settings.search')}
                            onChange={this.handleSearchFilter}
                        />
                    </Grid>
                </Grid>
            </React.Fragment>
        )
        
        let success = showResponseDialog ?
            <SuccesAnimated
                type={responseStatus}
                open={showResponseDialog}
                handleClose={() => { this.setState({ showResponseDialog: false }) }}>
                <div className="admin-config-modal-text">{responseStatusText}</div>
            </SuccesAnimated> : '';

        const deleteContentText = t('settings.deleteContent', { configurationType: t('configurationTypes.setup').toLowerCase() });
        const archiveContentText = t('settings.archiveContent', { configurationType: t('configurationTypes.setup').toLowerCase() });

        return (
            <section className="admin-config-content">
                {header}
                <ConfigurationSetTable
                    className="admin-config-table"
                    sortBySelected={sortBySelected}
                    sortBy={this.sortBy}
                    sortOrder={sortOrder}
                    filteredsettingList={paginatedList}
                    dateFormat={this.props.dateFormat}
                    hyperfinds={hyperFindList}
                    rightPanelHandler={this.rightPanelHandler}
                />
                {filteredCount > 0 && (
                    <div className="admin-config-pagination">
                        <div className="admin-config-pagination-page-size">
                            <Typography variant="body2" style={{ paddingTop: '8px', marginRight: '8px' }}>
                                {t('common:tablePagination.rowsPerPage')}:
                            </Typography>
                            <ReactSelect
                                value={selectedPageSize}
                                options={PAGE_SIZE_OPTIONS}
                                onChange={this.handlePageSizeChange}
                                customStyles={{
                                    control: styles => ({
                                        ...styles,
                                        border: '1px solid #CCCCCC',
                                        minHeight: 25,
                                        height: 25,
                                        minWidth: 80
                                    }),
                                    valueContainer: styles => ({
                                        ...styles,
                                        padding: '0 8px'
                                    }),
                                    singleValue: styles => ({
                                        ...styles,
                                        marginTop: 2
                                    }),
                                    input: styles => ({
                                        ...styles,
                                        margin: 0,
                                        padding: 0
                                    }),
                                    dropdownIndicator: styles => ({
                                        ...styles,
                                        padding: 2
                                    }),
                                    menu: styles => ({
                                        ...styles,
                                        zIndex: 100
                                    })
                                }}
                            />
                        </div>
                        <Typography variant="body2" style={{ paddingTop: '8px' }}>
                            {t('common:tablePagination.fromToCount', { from, to, count: filteredCount })}
                        </Typography>
                        <Pagination
                            count={totalPages}
                            page={currentPage}
                            onChange={this.handlePageChange}
                            color="primary"
                            size="small"
                            showFirstButton
                            showLastButton
                        />
                    </div>
                )}
                <SideBar
                    className="admin-config-sidebar"
                    handleDrawerClose={this.closePanelHandler}
                    open={openForm}
                    title={formTitle}
                    isCloseOnOutsideClick={false}
                >
                    <Form
                        action={sideAction}
                        actionTypeList={actionTypeList}
                        awardingRulesList={awardingRulesList}
                        breRuleSetList={breRuleSetList}
                        cancel={this.cancelAction}
                        dataviewList={dataviewList}
                        genericNotificationList={genericNotificationList}
                        handleSubmitForm={this.handleSubmitForm}
                        hyperFindList={hyperFindList}
                        onNameError={() => this.handleSnackbar('error', t('form.nameUnique'), true)}
                        payCodeList={payCodeList}
                        segmentTagsList={segmentTagsList}
                        settingList={settingList}
                        settingSelected={settingSelected}
                        timePeriodRatioOptions={timePeriodRatioOptions}
                        workRuleList={workRuleList}
                        privateEmployeeSources={privateEmployeeSources}
                        ptoActionOnRejectionOptions={ptoActionOnRejectionOptions}
                        breakRuleList={breakRuleList}
                    />
                </SideBar>
                <Backdrop
                    showSpinner={displaySpinner}
                    showback={true}
                />
                <Snackbar
                    type={typeSnackbar}
                    message={messageSnackbar}
                    open={openSnackbar}
                    closeSnackbar={this.closeSnackbar}
                    bodyStyle={{ whiteSpace: 'pre-line' }}
                />
                <SimpleDialog
                    open={showDeleteDialog}
                    title={t('settings.delete')}
                    contentText={deleteContentText}
                    submit={this.deleteItem}
                    cancel={this.cancelAction}
                />
                <SimpleDialog
                    open={showArchiveDialog}
                    title={t('settings.archive')}
                    contentText={archiveContentText}
                    submit={this.archiveItem}
                    cancel={this.cancelAction}
                />
                {success}
            </section>
        );
    }
}

const mapStateToProps = state => {
    return {
        settingList: state.adminAppData.settingList,
        hyperFindList: state.adminAppData.hyperfinds,
        segmentTagsList: state.adminAppData.segmentTagsList,
        breRuleSetList: state.adminAppData.breRuleSetList,
        workRuleList: state.adminAppData.workRuleList,
        dataviews: state.adminAppData.dataviews,
        payCodeList: state.adminAppData.payCodeList,
        awardingRulesList: state.adminAppData.awardingRulesList,
        genericNotificationList: state.adminAppData.genericNotificationList,
        timePeriodRatioOptions: state.adminAppData.timePeriodRatioOptions,
        isConfigurationSetAppDataLoaded: state.adminAppData.isConfigurationSetAppDataLoaded,
        breakRuleList: state.adminAppData.breakRuleList,
    };
  };

const mapDispatchToProps = dispatch => {
    return {
        fetchConfigurationSetAppData: () => dispatch(fetchConfigurationSetAppData()),
        refreshConfigurationSets: () => dispatch(refreshConfigurationSets()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(['employmentBillboard'])(EBAdminSettings));
